<template>
	<div class="f12">
    <div class="h260 bg063069 dCC aic">
      <p class="f44 cfff">帮助中心</p>
      <p class="f24 cABD5FF">Help Center</p>
      <div class="mt10 fStart">
        <div class="pr">
          <Input class="hl42" ref="clickShow" style="width:602px; height: 42px;" v-model="requestData.title" placeholder="请在此输入您的问题，例：开户" @on-keyup="getValue" @on-focus="getValue" />

          <p class="pa t0 r0 hl42 btrr3 bbrr3 plr15 cfff bg4772FF f16 cp" @click="getList('request')">
            <Icon class="mr5" color="#fff" size=20 type="ios-search" />搜 索
          </p>

          <ul ref="clickShow" v-if="searchData.length > 0 && isShow" class="pa bgfff w100b tl bs31 br3">
            <li class="hl30 plr15 cp bgFAFAFAh" v-for="(search, index) in searchData" @click="toDetail(search)">{{search.title}}</li>
          </ul>
        </div>

        <Button class="ml38 cfff bg44A842 f16 w157 hl42 p0" type="text" @click="handleCustomerBtn()">
          <svg-icon icon-class="rzline-headset"></svg-icon>
          在线客服帮助
        </Button>
      </div>
    </div>

    <div class="bgF6F4F5 tl">
     <div class="main_width m0a pt13 pb30">
        <p class="hl74 f24" v-if="hotDataStatus">热门问题</p>
        <div class="helpHot fSpace mt5" v-if="hotDataStatus">
          <div class="w33b bs31 bgfff mr35 plr20 ptb28" v-for="(hot,index) in hotData" :style="index == 2 ? 'margin-right:0px;' : ''">
            <p class="cE1241A f1f mb18 f16">{{hot.typeName}}</p>

            <p class="f14 mb14 otw" v-for="(hotDetail, detailIndex) in hot.typeList">
              <router-link class="c4772FF" :to="'/Help/Detail/' + hotDetail.helpInfoId">{{hotDetail.title}}</router-link>
            </p>
          </div>
        </div>

        <div class="mt39"><router-view/></div>
      </div>
    </div>
  </div>
</template>

<script>
  import store from '@/store/store';

  let _this = '';
  let reg = /[^\u4E00-\u9FA5]/;

  export default{
    store, // 引用

    data(){
      return {
        isShow: true,

        requestData: {
          page:1,
          rows:8,
          title: ''
        },
        searchData: [],

        hotData:[], // 热门问题

        hotDataStatus: false, // 展示热门问题
      }
    },
    methods: {
      // 搜索获取内容
      getValue(e){
        let val = e.target.value;
        if (val){
          this.requestData.title = val
          this.getList();
        }else{
          this.searchData = [];
        }
      },

      // 跳转详情页
      toDetail(row){
        this.$set(this.requestData, 'title', row.title);

        this.$router.push(`/Help/Detail/${row.id}`);
        this.isShow = false;
      },

      // 获取列表
      getList(tip){
        this.sendOther({
          url: '/web/independent/help/page',
          data: this.requestData
        }, (result)=>{
          // console.log("ack回调", result.data);
          this.searchData = result.data.data;
          this.isShow = true;

          // 如果点击搜索按钮，并且返回为空
          if (tip && this.searchData.length == 0){
            this.$Message.info('没有搜索到任何信息');
          }
        }, (result)=>{
          // console.log("其他回调", result);
        })
      },

      // 获取热门问题
      getHot(){
        this.sendGet({
          url: '/web/independent/help/findHotList',
        }, (result)=>{
          // console.log("ack回调", result.data);
          this.hotData = result.data.data;
        }, (result)=>{
          // console.log("其他回调", result);
        })
      },
    },
    created(){
      _this = this;
      this.getHot();  // 获取热门问题

      if(this.$route.name == 'Detail') {
        this.hotDataStatus = false;
      }else {
        this.hotDataStatus = true;
      }
    },
    updated() {
      if(this.$route.name == 'Detail') {
        this.hotDataStatus = false;
      }else {
        this.hotDataStatus = true;
      }
    }
  }
</script>

<style>
  ul,li{
    list-style: none;
  }
  .helpHot a:hover{
    color: #E1241A !important;
  }
  .hl42 .ivu-input {
    height: 42px !important;
    line-height: 42px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/help/Help.vue